export default __webpack_public_path__ + "static/media/4.630df307.jpg";